var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: _vm.namespace() },
    [
      _vm.option.layout === "mbg"
        ? _c("mbg", {
            ref: "table",
            attrs: {
              namespaced: _vm.namespaced,
              skin: _vm.skin,
              formatter: _vm.formatter,
              hover: _vm.hover,
              option: _vm.option,
              groupKey: _vm.groupKey,
              columns: _vm.columns,
              rows: _vm.rows,
              selectRowIds: _vm.selectRowIds,
              focusRowId: _vm.focusRowId,
              labels: _vm.labels,
              sortColumn: _vm.sortColumn,
              scrollTop: _vm.scrollTop,
              scrollLeft: _vm.scrollLeft,
              columnWidth: _vm.columnWidth,
              hoverRow: _vm.hoverRow,
              frozenGroupHeader: _vm.frozenGroupHeader
            },
            on: {
              "rows-selected-changed": function($event) {
                return _vm.$emit("rows-selected-changed", $event)
              },
              "icon-click": _vm.onIconClick,
              "visible-rows-update": function($event) {
                return _vm.$emit("visible-rows-update", $event)
              },
              "cell-click": function($event) {
                return _vm.$emit("cell-click", $event)
              },
              "row-click": function($event) {
                return _vm.$emit("row-click", $event)
              },
              "row-double-click": function($event) {
                return _vm.$emit("row-double-click", $event)
              },
              "row-mouse-enter": function($event) {
                return _vm.$emit("row-mouse-enter", $event)
              },
              "row-mouse-leave": function($event) {
                return _vm.$emit("row-mouse-leave", $event)
              },
              "cell-mouse-enter": function($event) {
                return _vm.$emit("cell-mouse-enter", $event)
              },
              "cell-mouse-leave": function($event) {
                return _vm.$emit("cell-mouse-leave", $event)
              },
              "render-complete": function($event) {
                return _vm.$emit("render-complete", $event)
              },
              scroll: _vm.onScroll,
              sort: function($event) {
                return _vm.$emit("sort", $event)
              },
              "column-width-changed": function($event) {
                return _vm.$emit("column-width-changed", $event)
              }
            }
          })
        : _c("markets-table", {
            ref: "table",
            attrs: {
              namespaced: _vm.namespaced,
              skin: _vm.skin,
              formatter: _vm.formatter,
              hover: _vm.hover,
              option: _vm.option,
              groupKey: _vm.groupKey,
              columns: _vm.columns,
              rows: _vm.rows,
              selectRowIds: _vm.selectRowIds,
              focusRowId: _vm.focusRowId,
              labels: _vm.labels,
              sortColumn: _vm.sortColumn
            },
            on: {
              "rows-selected-changed": function($event) {
                return _vm.$emit("rows-selected-changed", $event)
              },
              "icon-click": _vm.onIconClick,
              "visible-rows-update": function($event) {
                return _vm.$emit("visible-rows-update", $event)
              },
              "cell-click": function($event) {
                return _vm.$emit("cell-click", $event)
              },
              "row-click": function($event) {
                return _vm.$emit("row-click", $event)
              },
              "row-double-click": function($event) {
                return _vm.$emit("row-double-click", $event)
              },
              "row-mouse-enter": function($event) {
                return _vm.$emit("row-mouse-enter", $event)
              },
              "row-mouse-leave": function($event) {
                return _vm.$emit("row-mouse-leave", $event)
              },
              "cell-mouse-enter": function($event) {
                return _vm.$emit("cell-mouse-enter", $event)
              },
              "cell-mouse-leave": function($event) {
                return _vm.$emit("cell-mouse-leave", $event)
              },
              "render-complete": function($event) {
                return _vm.$emit("render-complete", $event)
              }
            }
          }),
      _vm._v(" "),
      _vm.computedHover.menu.length
        ? _c(
            "markets-ui-popover",
            {
              class: _vm.namespace("popover"),
              attrs: {
                namespaced: _vm.namespaced,
                visible: _vm.popover.visible,
                target: _vm.popover.target,
                skin: _vm.skin,
                width: _vm.computedHover.width
              },
              on: { hide: _vm.hideHoverMenu }
            },
            [
              _c(
                "header",
                {
                  class: [
                    _vm.mdsNS("popover__header"),
                    _vm.namespace("__header"),
                    _vm.skinStyle
                  ]
                },
                [
                  _c("div", { class: _vm.namespace("__header-title") }, [
                    _c("h3", { class: _vm.mdsNS("popover__title") }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.computedHover.title) +
                          "\n                "
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.mdsNS("popover__content") },
                [
                  _c("markets-ui-list", {
                    attrs: {
                      namespaced: _vm.namespaced,
                      skin: _vm.skin,
                      "data-model": _vm.computedHover.menu
                    },
                    on: {
                      change: _vm.clickHoverMenu,
                      click: _vm.clickHoverMenu
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }